export function setEmbedTenant(tenant: string) {
  if (typeof window !== 'undefined') {
    window.__BR_EMBED_TENANT__ = tenant ? String(tenant).trim().toLowerCase() : null;
  }
}

export function getTenantHeader() {
  if (typeof window !== 'undefined' && window.__BR_EMBED_TENANT__) {
    return window.__BR_EMBED_TENANT__;
  }

  if (typeof window === 'undefined') {
    return process.env.REACT_APP_TENANT_DEFAULT || '';
  }

  const hostname = window.location.hostname;
  const identifier = hostname.substring(0, hostname.indexOf('.')).toLowerCase();
  return identifier || process.env.REACT_APP_TENANT_DEFAULT || '';
}

declare global {
  interface Window {
    __BR_EMBED_TENANT__?: string | null;
  }
}

export {};
